import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserPlus,
  faUserCheck,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import Modal from "../../../components/ui/modal";

const ChooseOwnerOptionModal = ({
  isOpen,
  onClose,
  onRegisterNew,
  onAssignExisting,
}) => {
  const options = [
    {
      key: "register",
      icon: faUserPlus,
      title: "Add new owner",
      description:
        "Create new shop owner account with login credentials and link them to this shop.",
      accent: "blue",
      onClick: onRegisterNew,
    },
    {
      key: "assign",
      icon: faUserCheck,
      title: "Assign existing owner",
      description:
        "Pick an owner already registered in the system and link them to this shop.",
      accent: "orange",
      onClick: onAssignExisting,
    },
  ];

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Add Owner"
      maxWidth="sm:max-w-lg"
    >
      <div className="flex flex-col gap-3 pb-8">
        <p className="text-sm text-gray-600 font-medium">
          Choose how you want to add an owner to this shop.
        </p>

        {options.map((opt) => (
          <button
            key={opt.key}
            type="button"
            onClick={() => {
              onClose();
              opt.onClick();
            }}
            className={`group flex items-start gap-4 p-4 rounded-lg border-2 transition-all duration-200 text-left ${
              opt.accent === "blue"
                ? "border-blue-100 hover:border-blue-500 hover:bg-blue-50/50"
                : "border-orange-100 hover:border-orange-600 hover:bg-orange-50/50"
            }`}
          >
            <div
              className={`w-11 h-11 shrink-0 rounded-full flex items-center justify-center ${
                opt.accent === "blue"
                  ? "bg-blue-100 text-blue-700"
                  : "bg-orange-100 text-orange-600"
              }`}
            >
              <FontAwesomeIcon icon={opt.icon} className="h-5 w-5" />
            </div>
            <div className="flex-1">
              <p className="font-semibold text-gray-900 text-sm">{opt.title}</p>
              <p className="text-sm text-gray-600 mt-0.5 leading-relaxed">
                {opt.description}
              </p>
            </div>
            <FontAwesomeIcon
              icon={faArrowRight}
              className={`self-center h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-0.5 ${
                opt.accent === "blue" ? "text-blue-500" : "text-orange-600"
              }`}
            />
          </button>
        ))}
      </div>
    </Modal>
  );
};

export default ChooseOwnerOptionModal;
